import { RootState } from '../../RootState';

export const getPaymentSettingsState = (state: RootState) => state.PaymentsState.common.paymentSettings;
export const getFundingSourceIdForMicroDeposit = (state: RootState) => state.PaymentsState.common.initiateMicroDeposit.sourceId;
export const getFundingSourceId = (state: RootState) => state.PaymentsState.common.dwollaAddFundingSource.fundingSourceId;